import "./style.scss"

import 'master';
import $ from 'jquery';
import 'fullcalendar';

var _dataEventList = [{
    'title': 'Louis Moreau Chablis Master Class',
    'start': '2020-01-24T13:13:55.008',
    'end': '2019-01-24T18:13:55.008',
    'thumbSrc': '../../assets/images/news-event-thumb-1.jpg',
    'time': 'OCT 9, 12:15 - 3:15pm',
    'link': '#',
    'desc': 'Wine tasting session with winemaker Louis Moreau and his wife Anne Moreau. Louis and his wife Anne own parcels in four of Chablis seven grand cru climats. All of Louis’ decisions in the vineyard and cellar are meant to bring out the personality of each terroir.'

  },
  {
    'title': 'Louis Moreau Chablis Master Class 2',
    'start': '2019-12-24T13:13:55.008',
    'end': '2019-12-24T18:13:55.008',
    'thumbSrc': '../../assets/images/news-event-thumb-1.jpg',
    'time': 'OCT 9, 12:15 - 3:15pm',
    'link': '#',
    'desc': 'Wine tasting session with winemaker Louis Moreau and his wife Anne Moreau. Louis and his wife Anne own parcels in four of Chablis seven grand cru climats. All of Louis’ decisions in the vineyard and cellar are meant to bring out the personality of each terroir.'

  },
  {
    'title': 'Event Title Xmas',
    'start': '2019-12-24T08:13:55.008',
    'end': '2019-12-24T09:13:55.008',
    'thumbSrc': '../../assets/images/news-event-thumb-1.jpg',
    'time': 'OCT 9, 12:15 - 3:15pm',
    'link': '#',
    'desc': 'Wine tasting session with winemaker Louis Moreau and his wife Anne Moreau. Louis and his wife Anne own parcels in four of Chablis seven grand cru climats. All of Louis’ decisions in the vineyard and cellar are meant to bring out the personality of each terroir.'
  },
  {
    'title': 'Event Title Xmas 2',
    'start': '2019-12-24T03:13:55.008',
    'end': '2019-12-24T08:13:55.008',
    'thumbSrc': '../../assets/images/news-event-thumb-1.jpg',
    'time': 'OCT 9, 12:15 - 3:15pm',
    'link': '#',
    'desc': 'Wine tasting session with winemaker Louis Moreau and his wife Anne Moreau. Louis and his wife Anne own parcels in four of Chablis seven grand cru climats. All of Louis’ decisions in the vineyard and cellar are meant to bring out the personality of each terroir.'
  },
  {
    'title': 'Event Title2',
    'start': '2019-12-17T13:13:55-0400',
    'end': '2015-12-19T13:13:55-0400',
    'thumbSrc': '../../assets/images/news-event-thumb-1.jpg',
    'time': 'OCT 9, 12:15 - 3:15pm',
    'link': '#',
    'desc': 'Wine tasting session with winemaker Louis Moreau and his wife Anne Moreau. Louis and his wife Anne own parcels in four of Chablis seven grand cru climats. All of Louis’ decisions in the vineyard and cellar are meant to bring out the personality of each terroir.'
  },
  {
    'title': 'Event Title4',
    'start': '2019-12-18T13:13:55-0400',
    'end': '2015-12-19T13:13:55-0400',
    'thumbSrc': '../../assets/images/news-event-thumb-1.jpg',
    'time': 'OCT 9, 12:15 - 3:15pm',
    'link': '#',
    'desc': 'Wine tasting session with winemaker Louis Moreau and his wife Anne Moreau. Louis and his wife Anne own parcels in four of Chablis seven grand cru climats. All of Louis’ decisions in the vineyard and cellar are meant to bring out the personality of each terroir.'
  }
];

$(function() {

  calViewInit();

 

  $('.box-view-mode button').click(function() {
    $(this).toggleClass('grid');
    if (!$(this).hasClass('grid')) {
      $('#calendar').hide();
      $('.cal-view-listing').fadeIn();
      calListDataStatus();
    } else {
      $('#calendar').fadeIn();
      $('.cal-view-listing').hide();
    }

  });


  var _calendar = $('#calendar').fullCalendar('getCalendar');

  getCurMonth();

  $('.cal-prev').click(function() {
    _calendar.prev();
    getCurMonth();
    $('.cal-view-listing ul').empty();
    $('#calendar').fullCalendar('rerenderEvents');
    calListDataStatus();
  });
  $('.cal-next').click(function(e) {
    _calendar.next();
    getCurMonth();
    $('.cal-view-listing ul').empty();
    $('#calendar').fullCalendar('rerenderEvents');
    calListDataStatus();
  });

  $('.event-calendar-top-bar .comp-data-sel-mobi select').change(function(){
    //console.log($(this).val());
    getCurMonth();
    $('#calendar').fullCalendar('gotoDate',$(this).val());
    $('.cal-view-listing ul').empty();
    $('#calendar').fullCalendar('rerenderEvents');
    calListDataStatus();
  })

  $(window).scroll(function() {
    var $eventLoader = $('.comp-event-loader');
    if ($eventLoader.hasClass('on')) {
      $('.comp-event-loader.on').remove();
    }
  });

  $(".shareSocialBtnWrapper .shareSocialBtn").mouseenter(function() {
    $(".shareSocialList").addClass("active");
  });
  $(".shareSocialBtnWrapper").mouseleave(function() {
      $(".shareSocialList").removeClass("active");
  });
});

function calListDataStatus(){
  
  if(($('.cal-view-listing ul li').length)<=0){
    $('.cal-view-listing .message').fadeIn();
  }else {
    $('.cal-view-listing .message').hide();
  };
}

function calViewInit() {

  $('#calendar').fullCalendar({
    dayNamesShort: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    events: _dataEventList,
    eventClick: function(info) {
      var $eventLoader = $('.comp-event-loader');
      $('.thumb img', $eventLoader).attr('src', info.thumbSrc);
      $('h4', $eventLoader).empty().html(info.title);
      $('.date', $eventLoader).empty().html(info.time);
      $('.arrowLink', $eventLoader).attr('href', info.link);

      $('.comp-event-loader.on').remove();
      $eventLoader.clone().addClass('on').insertAfter($(this));

    },
    eventRender: function(eventObj, event) {

      var _dataEventListing = [];

      _dataEventListing.push('<li><div class="event-item"><span class="thumb"><img src="' + eventObj.thumbSrc + '"></span><div class="inner"><h4>' + eventObj.title + '</h4><span class="date">' + eventObj.time + '</span><p>' + eventObj.desc + '</p><a class="arrowLink" href="' + eventObj.link + '">Learn more</a></div></div></li>');

      $('.cal-view-listing ul').append(_dataEventListing);

    },
    viewRender: function(event, view) {

      $('.fc-content-skeleton thead td').each(function() {
        $(this).append($('<span>', {
          'class': 'stroke'
        }));
      });

    }
  });

}

function getCurMonth() {
  var _curMonthStr,
    $targetMonthEl = $('.fc-header-toolbar h2');

  _curMonthStr = $targetMonthEl.text();
  $('.curMonth').text(_curMonthStr);
}
